const firebaseConfig = {
  apiKey: "AIzaSyAqJrhR9hcme0SNI8Ry4E5gEK0X8bygogQ",
  authDomain: "cure-it-cancer-center.firebaseapp.com",
  projectId: "cure-it-cancer-center",
  storageBucket: "cure-it-cancer-center.appspot.com",
  messagingSenderId: "1019504125871",
  appId: "1:1019504125871:web:21c1b57d95ee0de90f715a",
  measurementId: "G-B96NB3YBJ0"
};

export default firebaseConfig;